// src/plugins/vant.js
import Vant from 'vant';
import 'vant/lib/index.css';

export function setupVant(app) {
    app.use(Vant);
}
